import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import { createPinia } from 'pinia';
import Quasar from 'quasar/src/vue-plugin.js';import setCssVar from 'quasar/src/utils/set-css-var.js';;
import App from './App.vue';
import router from './router';
import quasarUserOptions from './quasar-user-options';
import messages from './messages/message.json';
import '@quasar/extras/mdi-v5/mdi-v5.css';
import './styles/base.css';
import './styles/table-layout.css';
import './styles/common-layout.css';

const i18n = createI18n({
  legacy: false,
  locale: 'ja',
  globalInjection: true,
  messages,
});

const app = createApp(App);

// Error Handling
app.config.errorHandler = () => {
  router.replace({ name: 'error' })
}

app.use(Quasar, quasarUserOptions)
  .use(router)
  .use(createPinia())
  .use(i18n)
  .mount('#app');


setCssVar('pureWhite', '#fff');
setCssVar('pitchBlack', '#000');
setCssVar('white', '#fefefe');
setCssVar('cart', '#e77e5a');
setCssVar('approval', '#c8a22f');
setCssVar('unconfirmed', '#949494');
setCssVar('delete', '#6c6c6c');
setCssVar('subprimary', '#fdc400');
setCssVar('order', '#0066a4');
setCssVar('inquiry', '#93b881');
setCssVar('lightGray', '#f2f2f2');
setCssVar('gradientStart', '#006cb5');
setCssVar('gradientEnd', '#00a291');
setCssVar('redWarning', '#e60012');
setCssVar('supplementColor', '#5c5c5c');
setCssVar('borderBlack', '#3e3e3e');
setCssVar('lowDeleterious', '#6619bc');
setCssVar('lowPoison', '#649065');
setCssVar('lowPrtr', '#b67944');
setCssVar('lowSafety', '#21beca');
setCssVar('lightColorBorder', '#c2c2c2');
setCssVar('plainBlack', '#333');
setCssVar('disabledColor', '#a6a6a6');
setCssVar('opacityDisable', '#939393');
setCssVar('whiteBorder', '#cdcdcd');
setCssVar('tableHeaderBg', '#e1f2f7');
setCssVar('informationPublish', '#ff8958');
setCssVar('sidebarButtonColor', '#a9a9a9');
setCssVar('brightRed', '#ff0000');
